import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { history } from "../../utils/History";

import Table from "../../components/table";
import TableStatus from "../../components/table/status";
import SearchButton from "../../components/buttons/SearchButton";
import ResetFilterButton from "../../components/buttons/ResetFilterButton";
import ActiveFilterChips from "../../components/filters/ActiveFilterChips";
import FilteredEmptyState from "../../components/emptyState/FilteredEmptyState";
import HeaderMenu from "../../components/commons/menu/HeaderMenu";
import DetailButton from "../../components/table/detailButton";
// import MenuItem from "@material-ui/core/MenuItem";
import ConfirmationModal from "../../components/modal/ConfirmModal";
import Voucher from '../../store/actions/voucher/Index'

import VoucherModal from "./VoucherModal";
import moment from "moment";
import localization from "moment/locale/id";

import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import useLatestRequest from "../../components/hooks/useLatestRequest";
import CopyableText from "../../components/commons/CopyableText";
import {
  createDetailLocation,
  enumParam,
  hasNonDefaultQuery,
  pageSizeParam,
  positivePage,
  stringParam,
  useListQueryState,
} from "../../utils/listQueryState";
import { quotedSearchLabel } from "../../utils/filterChips";

const VOUCHER_QUERY_SCHEMA = {
    page: positivePage,
    length: pageSizeParam,
    search: stringParam(),
    status: enumParam(["", "claimed", "unclaimed"], ""),
};

const VOUCHER_STATUS_LABELS = {
    "": "Semua",
    claimed: "Diklaim",
    unclaimed: "Belum diklaim",
};

const Index = ({ loggingIn }) => {

    const [dataVoucher, setDataVoucher] = useState([]);
    const [dataVoucherRow, setDataVoucherRow] = useState([]);
    
    const [claimVoucherModal, setClaimVoucherModal] = useState(false);

    const { state: query, updateQuery, resetQuery, location } = useListQueryState(VOUCHER_QUERY_SCHEMA);
    const { page, length, search: searchText, status } = query;
    const hasActiveFilters = hasNonDefaultQuery(
        query,
        VOUCHER_QUERY_SCHEMA,
        ["search", "status"]
    );
    const filter = status === "claimed" ? "diklaim" : status === "unclaimed" ? "belum diklaim" : "";
    const [totalData, setTotalData] = useState(null);
    const [maxPage, setMaxPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [loadError, setLoadError] = useState(null);
    const { beginRequest, isLatestRequest } = useLatestRequest();

    const [values, setValues] = React.useState([
        "Semua",
        "Diklaim",
        "Belum diklaim"
      ]);
    const selected = VOUCHER_STATUS_LABELS[status];
    const resetAllFilters = () => resetQuery(["page", "search", "status"]);
    const activeFilterChips = [
        searchText && {
            key: "search",
            label: quotedSearchLabel(searchText),
            onRemove: () => updateQuery({ page: 1, search: "" }),
        },
        status && {
            key: "status",
            label: `Status: ${VOUCHER_STATUS_LABELS[status] || status}`,
            onRemove: () => updateQuery({ page: 1, status: "" }),
        },
    ].filter(Boolean);

    const handleChange = (event) => {
        const nextStatus = event.target.value === "Diklaim"
            ? "claimed"
            : event.target.value === "Belum diklaim"
                ? "unclaimed"
                : "";
        updateQuery({ page: 1, status: nextStatus });
    }
    
    // const dataVoucher = [
    //     {
    //       "no" : "1",
    //       "id_voucher" : "8274ebd71",
    //       "nama_pemenang" : "Suhendra Darmawan",
    //       "no_wa" : "0854637264432",
    //       "promo_name" : "Promo Januari",
    //       "id_kasir" : "1234432",
    //       "status" : 0,
    //     },
    //     {
    //       "no" : "2",
    //       "id_voucher" : "8274ebd71",
    //       "nama_pemenang" : "Suhendra Darmawan",
    //       "no_wa" : "0854637264432",
    //       "promo_name" : "Promo februari",
    //       "id_kasir" : "1234432",
    //       "status" : 0,
    //     },
    //     {
    //       "no" : "3",
    //       "id_voucher" : "8274ebd71",
    //       "nama_pemenang" : "Suhendra Darmawan",
    //       "no_wa" : "0854637264432",
    //       "promo_name" : "Promo maret",
    //       "id_kasir" : "1234432",
    //       "status" : 1,
    //     },
    //     {
    //       "no" : "4",
    //       "id_voucher" : "8274ebd71",
    //       "nama_pemenang" : "Suhendra Darmawan",
    //       "no_wa" : "0854637264432",
    //       "promo_name" : "Promo april",
    //       "id_kasir" : "1234432",
    //       "status" : 1,
    //     },
    //   ];

    const dispatch = useDispatch();
    useEffect(() => {
      handleRefresh();
    }, [searchText, filter, page, length]);

    const handleSearch = (value) => {
        updateQuery({ page: 1, search: value?.length > 0 ? value : "" });
    }

    const handleRefresh = () => {
        const requestId = beginRequest();
        setIsLoading(true);
        setLoadError(null);
        new Promise((resolve, reject) => {
            let param = {
                page: page ? page : 1,
                length,
                search_text: searchText,
                filter_status: filter
            }
            dispatch(Voucher.get(param, resolve, reject));
        })
            .then(res => {
                if (!isLatestRequest(requestId)) return;

                setDataVoucher(res?.data ?? [])
                setTotalData(res?.totalCount ?? 0)
                const nextMaxPage = Math.max(1, Math.ceil((res?.totalCount ?? 0) / length));
                setMaxPage(nextMaxPage)
                if (page > nextMaxPage) updateQuery({ page: nextMaxPage });
            })
            .catch((error) => {
                if (!isLatestRequest(requestId)) return;

                setLoadError(error?.response?.data?.message ?? "Data voucher gagal dimuat.")
            })
            .finally(() => {
                if (isLatestRequest(requestId)) {
                    setIsLoading(false)
                }
            })
    }

    const showClaimVoucherModal = (data) => {
        setClaimVoucherModal(!claimVoucherModal)
    }

    const handleKlaim = (param) => {
        const callback = () => {
            handleRefresh()
            setClaimVoucherModal(!claimVoucherModal)
        }

        dispatch(Voucher.claimVoucher(param, callback));
    };

    const columns = [
        {
        Header: "NO",
        accessor: "no",
        },
        {
        Header: "ID BARCODE VOUCHER",
        accessor: "id_barcode",
        Cell: ({ value }) => (
            <CopyableText value={value} label="Kode voucher" />
        ),
        },
        {
        Header: "NAMA PEMENANG",
        accessor: "nama_pemenang",
        },
        {
        Header: "NO WHATSAPP",
        accessor: "no_whatsapp",
        Cell: ({ value }) => (
            <CopyableText value={value} label="Nomor WhatsApp" />
        ),
        },
        {
        Header: "NAMA PROMO",
        accessor: "nama_promo",
        },
        {
            Header: "STATUS",
            accessor: "status",
            Cell: ({ row }) => {
              const { original } = row;
              const { status_klaim } = original;
      
              return (
                <TableStatus
                  status={
                    status_klaim === 0 ? 
                      "Belum Diklaim" : "Diklaim"
                  }
                  color={
                    status_klaim === 0 ? 
                      "notAvailable" : "available"
                  }
                  outline
                />
              );
            },
        },
        {
        Header: "",
        accessor: "actions",
        Cell: ({ row }) => {
            const { original } = row;

            return (
                <DetailButton>
                    <MenuItem onClick={() => history.push(createDetailLocation(`/voucher-detail/${original?.id}`, location))}>
                        <span style={{ fontSize: 14 }}>Detail</span>
                    </MenuItem>
                </DetailButton>
            );
            
        },
        },
    ];

    return (
        <div className="menu-container">
            <div>
                <HeaderMenu
                    title="Voucher"
                    toolbarClassName="page-header-toolbar-split voucher-toolbar"
                    secondaryContent={hasActiveFilters ? <ActiveFilterChips chips={activeFilterChips} /> : null}
                >
                    <SearchButton
                        placeholder="Cari voucher"
                        value={searchText}
                        toggle={(value) => handleSearch(value)}
                    />
                    <div className="dropdown voucher-status-filter rounded-button button-white">
                        <Select
                            value={selected}
                            onChange={handleChange}
                            inputProps={{
                            name: "voucher",
                            id: "voucher-id"
                            }}
                            disableUnderline
                            style={{ width:'100%'}}
                        >
                            {values.map((value, index) => {
                            return <MenuItem value={value}>{value}</MenuItem>;
                            })}
                        </Select>
                    </div>
                    <ResetFilterButton
                        visible={hasActiveFilters}
                        onClick={resetAllFilters}
                    />
                </HeaderMenu>
            </div>
            <div className="content-container-side">
                <div className="overflow">
                <Table
                    columns={columns}
                    data={dataVoucher}
                    loading={isLoading}
                    error={loadError}
                    onRetry={handleRefresh}
                    emptyContent={hasActiveFilters ? <FilteredEmptyState onReset={resetAllFilters} /> : null}
                    pagination={{
                        page,
                        totalData,
                        maxPage,
                        toggle: (nextPage) => updateQuery({ page: nextPage }),
                        length,
                        onPageSizeChange: (nextLength) => updateQuery({ page: 1, length: nextLength })
                    }}
                />
                </div>
            </div>

            {/* Modal */}
            <VoucherModal
                show={claimVoucherModal}
                toggle={showClaimVoucherModal}
                action={handleKlaim}
                type="add"
            />


        </div>

    );
};

export default Index;

